import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=7d9e3fd4&scoped=true&"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=7d9e3fd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9e3fd4",
  null
  
)

export default component.exports